import makeStyles from "@material-ui/core/styles/makeStyles";
import { createStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    titleBar: {
      textAlign: "start",
      backgroundColor: "#869ac4"
    },
    inputField: {
      width: "150px",
      marginLeft: "5px"
    },
    radioGroup: {
      display: "flex",
      flexDirection: "row",
      marginLeft: "5px"
    },
    tabLabel: {
      fontSize: "0.9rem"
    },
    root: {
      flexGrow: 1
    },
    button: {
      borderRadius: "5px",
      fontSize: "0.9rem"
    },
    dropDownField: {
      fontSize: "0.9rem",
      marginLeft: "10px",
      width: "100%"
    },
    errorMsg: {
      width: "150px",
      marginLeft: "5px",
      color: "red"
    }
  })
);
